const fb = {
    sendUserId: function() {
        const userId = localStorage.userId;
        if(userId) {
            window.fbq('init', '1893434544728918', {
                external_id: localStorage.userId
            });
        }
    },

    sendOfficeLogin: function() {
        window.fbq('track', 'CompleteRegistration', {
            value: 0.00,
            currency: 'USD',
            status: 'success',
            event_id: localStorage.userId
        });
    },

    sendPaymentInfo: function() {
        window.fbq('track', 'Subscribe', {
            value: 0.00,
            currency: 'USD',
            status: 'success',
            event_id: localStorage.userId
        });
    },

    sendLastPaymentInfo: function(amount,currency,id,date) {
        //do not send old payments. Duplicity for new payments should be filtered by google (with id).
        const paymentDate = new Date(date);
        const now = new Date();
        const maxTime14 = 14 * 24 * 60 * 60 * 1000;
        if(now.getTime() - paymentDate.getTime() <= maxTime14){
            window.fbq('track', 'Purchase', {
                value: amount,
                currency: currency,
                event_id: id
            });
        }
    }
}

export default fb;